import React from 'react';
import useInView from '../hooks/useInView';

function SectionHeader({ index, label, title, lead = '' }) {
  const [headRef, isVisible] = useInView();

  return (
    <header ref={headRef} className={`section-head reveal ${isVisible ? 'is-visible' : ''}`}>
      <p className="section-head__index mono">
        {index} — {label}
      </p>
      <h2 className="section-head__title">{title}</h2>
      {lead ? <p className="section-head__lead">{lead}</p> : null}
    </header>
  );
}

export default SectionHeader;
